import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FlashMessagesService } from 'flash-messages-angular';
import { SafeSubscribable } from 'src/app/core/rxjs/extensions';
import { RouteService } from 'src/app/core/services';
import { AdminService } from 'src/app/services/admin.service';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-new-register',
  templateUrl: './new-register.component.html',
  styleUrls: ['./new-register.component.css']
})
export class NewRegisterComponent implements OnInit, OnDestroy, SafeSubscribable {

  // Model
  model = {
    email: "",
    agencyName: "",
    firstName: "",
    lastName: "",
    password: "",
    type: "",
    confirmPassword: "",
    token: "",
  };

  constructor(private route: ActivatedRoute, private router: Router, private adminService: AdminService, private flashMessage: FlashMessagesService, private auth: AuthService, private routeService: RouteService) { }

  // Grab Parameters
  ngOnInit(): void {

    this.route.params.safeSubscribe(this, params => {

      // Get token from URL
      this.model.token = params['token']

      // Get Admin Info
      this.adminService.getNewRegister(this.model.token).toPromise().then((data: any) => {

        // Email
        this.model.email = data.User.email;

        // Agency
        if (!data.User.agencyID) {
          this.model.agencyName = "None"
        } else {
          this.model.agencyName = data.agency.agencyName;
        }

        // Type
        if (data.User.isSuperAdmin) {
          this.model.type = "Super Admin"
        } else {
          this.model.type = "Agency Admin"
        }
      })
    });
  }

  ngOnDestroy(): void {}

  // Register admin
  onSubmit() {
    this.adminService.registerAdmin(this.model).toPromise().then((data: any) => {

      // Success
      if (data.success) {

        // Store data
        this.auth.storeAdminData(data.token, data.user);

        // Store admin status
        this.auth.storeAdminStatus(true);

        // Redirect to home page
        this.routeService.redirectAfterLogin();

        // Display log in to user
        this.flashMessage.show("You have been logged in.", {
          cssClass: 'alert-success',
          timeout: 3000
        });
      }

      // Error
      else {

        // Display error
        this.flashMessage.show(data.message, {
          cssClass: 'alert-danger',
          timeout: 3000
        });
      }
    });
  }
}


